<!-- Read-only display of a submitted free-text answer. -->

<script lang="ts" setup>
import type { TextInputValue } from '@sigma/common/forms/TextInput.js';

interface Props {
  /** The text answer value to display. */
  value: TextInputValue;
}

defineProps<Props>();
</script>

<template>
  {{ value.value }}
</template>
